import { Routes, Route } from '@angular/router';
import { DashboardRouteContext, RouteContextItemType } from '@context/old_index';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { SysAdmin, FormsAdministrator } from './role-constants';
import { OidcAuthRouteGuardService } from '@auth/services/oidc-auth-route-guard';
import { RoleGuardService } from '@roles/services/role-guard.service';
import { PmaPermissionsGuardService } from '@roles/services/pma-permissions-guard.service';
import { WellKnownRoutePaths } from '@feature/routing/well-known-route-paths';
import { MfsProductService } from '@product/services/mfs-product.service';
import { MftProductService } from '@feature/product/services/mft-product.service';

/**
 *  Export and single statement return required for angular AOT compilation
 */
export function standardDashboardDesignerRoute(product: string, path: string, profileManagerPath: string): Route {
    return {
        data: {
            product: product,
            routeContext: DashboardRouteContext.create('None'),
            profileManagerPath: profileManagerPath,
            defaultRoute: '/main',
            roles: [
                SysAdmin
            ],
            pmaPermissions: [
                FormsAdministrator
            ],
        },
      path: path,
      loadChildren: () => import('@feature/_app_modules/mojo/dashboard-designer/dashboard-designer.module').then(m => m.DashboardDesignerModule),
        canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
    }
}

export const dashboardDesignerRoutes: Routes = [
  {
    data: {
      product: MojoWellKnownNames.Products.Mci,
      routeContext: DashboardRouteContext.create('None'),
      profileManagerPath: 'profile-config',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
    },
    path: 'mci-dashboard-designer',
    loadChildren: () => import('@feature/_app_modules/mojo/dashboard-designer/dashboard-designer.module').then(m => m.DashboardDesignerModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },
  {
    data: {
      product: MojoWellKnownNames.Products.MojoDashboard,
      routeContext: DashboardRouteContext.create('None'),
      profileManagerPath: WellKnownRoutePaths.MojoDashboards.manageProfiles,
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
    },
    path: 'mojo-dashboard-designer',
    loadChildren: () => import('@feature/_app_modules/mojo/dashboard-designer/dashboard-designer.module').then(m => m.DashboardDesignerModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },
  {
    data: {
      product: MojoWellKnownNames.Products.MojoForSuppliers,
      routeContext: DashboardRouteContext.create('None'),
      profileManagerPath: MfsProductService.manageProfiles,
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
    },
    path: 'mfs-dashboard-designer',
    loadChildren: () => import('@feature/_app_modules/mojo/dashboard-designer/dashboard-designer.module').then(m => m.DashboardDesignerModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },
  {
    data: {
      product: MojoWellKnownNames.Products.MojoForTenants,
      routeContext: DashboardRouteContext.create('None'),
      profileManagerPath: MftProductService.manageProfiles,
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
    },
    path: 'mft-dashboard-designer',
    loadChildren: () => import('@feature/_app_modules/mojo/dashboard-designer/dashboard-designer.module').then(m => m.DashboardDesignerModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },
];

